import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getAdminToken, getAdminRole } from './Common'

const SuperadminPrivateRoute = () => {
    const isLoggedIn = getAdminToken()
    const isSuperAdmin = getAdminRole() === 'superadmin'

    if (!isLoggedIn) {
        return <Navigate to="/admin/login" replace />
    }

    if (!isSuperAdmin) {
        return <Navigate to="/admin/access-denied" replace />
    }

    return <Outlet />
}

export default SuperadminPrivateRoute